<template>
  <div class="yiliao">
	<el-radio-group v-model="tabPosition1" @change="change">
      <el-radio-button label="1">
        <i class="el-icon-data-board"></i>
        <span>字段数据</span>
      </el-radio-button>
      <el-radio-button label="2">
        <i class="el-icon-data-line"></i>
        <span>图表趋势</span>
      </el-radio-button>
    </el-radio-group>
    <!-- 药店数据 -->
    <div class="u-flex u-col-center u-row-between u-flex-wrap" style="padding: 30px 0px;" v-show="tabPosition1==1&&datainfo.pharmacy_name">
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">行政区划代码</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.administrative}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">省份</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.province}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">地级市</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.city}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">区县城市</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.area}}</span>
			</div>
			
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">药房名称</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.pharmacy_name}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">企业名称</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.enterprise}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">是否医保定点</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.medical}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">单体/连锁</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.type}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">法定代表人</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.legal_person}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px;white-space: nowrap;overflow: hidden;
    text-overflow: ellipsis;">地址</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.address}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">联系电话</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.tel}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">邮箱</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.email}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">网址</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.url}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">注册资本(万元)</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.capital}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">成立日期</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.date_of_establishment}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">统一社会信用代码</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.credit}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">参保员工人数</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.insured}}</span>
			</div>
           
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">组织机构代码</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.organization}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">是否院边药房</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.is_have}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">是否有进出口贸易</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.trade}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">临近相关建筑</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.adjacent}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">经度</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.longitude}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">纬度</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.latitude}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">相关建筑距离（米）</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.distance}}</span>
			</div>
			  <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">经营范围</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.business}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">营业收入</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.accrued_revenues}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">主营业务收入</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.business_income}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">资产总额</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.total_assets}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">负债总额</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.total_liabilities}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">利润总额</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.total_profit}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">净利润</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.net_profit}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">纳税总额</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.total_tax}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">所有者权益合计</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.total_owners}}</span>
			</div>
			<div style="width: 220px;margin: 0 40px;"></div>
			<div style="width: 220px;margin: 0 40px;"></div>
		</div>
    <!-- 医院数据 -->
    <div class="u-flex u-col-center u-row-between u-flex-wrap" style="padding: 30px 0px;" v-show="tabPosition1==1&&datainfo.name">
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">行政区划代码</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.administrative}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">地级市</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.city}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">区县城市</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.area}}</span>
			</div>
			
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;" >
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">医院名称</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.name}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">医院级别</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.level}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">医院等次</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.grade}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">医院性质</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.nature}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">医院类型</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.h_type}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px;white-space: nowrap;overflow: hidden;
    text-overflow: ellipsis;">地址</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.address}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">联系电话</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.tel}}</span>
			</div>
      <!-- <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">重点科室</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.key_departments}}</span>
			</div> -->
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">执业_助理医师</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.physician}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">床位数</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.bed}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">急诊人次</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.treatment}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">出院人数</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.hospital}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">住院手术人次数</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.operation}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">医疗收入(万元)</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.income}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">门诊收入(万元)</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.outpatient_revenue}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">门诊_药品收入(万元)</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.outpatient_drug_income}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">住院收入(万元)</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.inpatient_income}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">住院_药品收入(万元)</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.inpatient_drug_income}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">药品收入(万元)</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.drug_income}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">西药收入(万元)</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.western_medicine_income}}</span>
			</div>
            <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">中药收入(万元)</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.tcm_revenue}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">医疗支出(万元)</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.medical_expenditure}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">药品支出(万元)</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.drug_expenditure}}</span>
			</div>
			  <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">中药支出(万元)</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.tcm_expenditure}}</span>
			</div>
      <div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;height:50px">西药支出(万元)</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;height:50px">{{datainfo.western_medicine_expenditure}}</span>
			</div>
      
			<div style="width: 220px;margin: 0 40px;"></div>
			<div style="width: 220px;margin: 0 40px;"></div>
		</div>
		 <div
      class="u-flex u-col-center u-row-between u-flex-wrap"
      style="padding: 50px 0 100px 0"
      v-show="tabPosition1 == 2"
    >
      <div style="width: 25%; height: 225px" id="bing1"></div>
      <div style="width: 25%; height: 225px" id="bing2"></div>
      <div style="width: 25%; height: 225px" id="bing3"></div>
      <div style="width: 25%; height: 225px" id="bing4"></div>
      <div style="width: 25%; height: 225px" id="bing5"></div>
      <div style="width: 25%; height: 225px" id="bing6"></div>
      <div style="width: 25%; height: 225px" id="bing7"></div>
      <div style="width: 25%; height: 225px" id="bing8"></div>
    </div>
        <!-- <div class="u-flex" style="margin-left:40px">
            <span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 96px;">经营范围</span>
				<span style="line-height:50px;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 1144px;padding-left: 16px;">{{datainfo.business}}</span>
        </div> -->

  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
    created(){
        this.datainfo=JSON.parse(this.$route.query.item)
		
        if(this.datainfo.name){//医院
          this.$route.meta.title=this.datainfo.name
		  this.getHospitalInfo()
        }else{//药房
          this.getMedicalInfo()
        this.$route.meta.title=this.datainfo.pharmacy_name

        }
    // this.changeselect();

    },
    data(){
        return{
			 tabPosition1: "1",
             datainfo: {},
			 list:[]
        }
    },
    methods:{
		getHospitalInfo(){
			this.$http({
					url: '/api/Bigdata/new_hospital_show',
					data: {
						id: this.datainfo.id,
					}
				}).then(res => {
					if (res.code == 1) {
						this.list=res.data
					} else {
						
					}
				})
		},
		getMedicalInfo(){
			this.$http({
					url: '/api/Bigdata/pharmacy_show',
					data: {
						id: this.datainfo.id,
					}
				}).then(res => {
					if (res.code == 1) {
						this.list=res.data
					} else {
						
					}
				})
		},
		change(e) {
       if (e == 2) {
        this.setbing();
      }
    },
	setbing() {
		
        if(this.datainfo.name){//医院
			var arr = [
        "执业医师数量",
        "床位数",
        "急诊人数",
        "出院人数",
        "住院手术人数",
        "医疗收入",
        "医疗支出",
      ];
		}else{
			var arr = [
        "营业收入",
        "主营业务收入",
        "资产",
        "负债",
        "利润",
        "净利润",
        "纳税",
      ];
		}
      

      arr.forEach((val, key) => {
        var chartDom = document.getElementById(`bing${key + 1}`);
        var myChart = echarts.init(chartDom);
        myChart.setOption({
          // legend: {},
          tooltip: {},
          graphic: {
            type: "text",
            left: "center",
            bottom: "0",
            style: {
              text: val,
              textAlign: "center",
              fill: "#222",
              fontSize: 14,
              fontWeight: 400,
            },
          },
          series: [
            {
              name: val,
              type: "pie", // 设置图表类型为饼图
              radius: "45%", // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
              label: {
                show: false,
              },
              itemStyle: {
                normal: {
                  color: function (colors) {
                    var colorList = ["#4B87FF", "#22D66C", "#5D7092"];
                    return colorList[colors.dataIndex];
                  },
                },
              },
              data: [
                // 数据数组，name 为数据项名称，value 为数据项值
                {
                  value: this.list[key].zongshu,
                  name: "总数",
                },
                {
                  value: this.list[key].tiaojian,
                  name: "统计",
                }
              ],
            },
          ],
        });
      });
    },
        changeselect() {
      this.$http({
        url: "/api/Bigdata/hospital_show",
        data: {
          grade: this.value2,
          lable: this.value3,
          type: this.value4,
          sheng: this.value1,
        },
      }).then((res) => {
        this.datainfo = res.data;
      });
    },
    }
}
</script>

<style lang="scss">
.yiliao {
  width: 1400px;
  // height: 840px;
  background: #ffffff;
  margin: 20px auto;
  padding: 30px 40px;

  .el-input__suffix {
    right: 0;
  }
  .lianji {
    .el-cascader {
      line-height: 38px;
      height: 38px;
    }

    .el-input__inner {
      border: none;
      line-height: 38px;
      height: 38px;
      background-color: #f7f7f7;
    }
  }
}
</style>
